class ShopifyJSONP {
  constructor() {
    this.counter = 0;
    this.callbacks = {};
  }
  
  request(url, params = {}) {
    return new Promise((resolve, reject) => {
      const callbackName = `jsonp_callback_${Date.now()}_${this.counter++}`;
      
      // 设置超时
      const timeoutId = setTimeout(() => {
        this.cleanup(callbackName);
        reject(new Error('JSONP request timeout'));
      }, 10000);
      
      // 注册回调
      this.callbacks[callbackName] = (data) => {
        clearTimeout(timeoutId);
        this.cleanup(callbackName);
        resolve(data);
      };
      
      // 构建URL
      const queryParams = new URLSearchParams({
        ...params,
        callback: callbackName
      });
      
      // 创建script标签
      const script = document.createElement('script');
      script.src = `${url}${url.includes('?') ? '&' : '?'}${queryParams.toString()}`;
      script.onerror = () => {
        clearTimeout(timeoutId);
        this.cleanup(callbackName);
        reject(new Error('JSONP request failed'));
      };
      
      // 挂载到全局对象
      window[callbackName] = this.callbacks[callbackName];
      
      document.head.appendChild(script);
    });
  }
  
  cleanup(callbackName) {
    delete window[callbackName];
    delete this.callbacks[callbackName];
    // 移除对应的script标签
    const scripts = document.querySelectorAll(`script[src*="${callbackName}"]`);
    scripts.forEach(script => script.remove());
  }
}

